import React from 'react';
import {useTranslation} from 'react-i18next';
import {Button} from '@tickchak/react-share/app';
import * as css from './AiAgentUserMessage.css';

interface AiAgentUserMessageEditActionsProps {
    index: number;
    onSave: () => void;
    onCancel: () => void;
}

function AiAgentUserMessageEditActions({index, onSave, onCancel}: AiAgentUserMessageEditActionsProps) {
    const {t} = useTranslation('aiAgent');

    return (
        <css.editActions>
            <Button
                variant="subtle"
                size="category"
                onClick={onCancel}
                data-cy={`ai-agent-user-message-edit-cancel-${index}`}
            >
                {t('cancel')}
            </Button>
            <Button
                variant="brand"
                size="category"
                onClick={onSave}
                data-cy={`ai-agent-user-message-edit-send-${index}`}
            >
                {t('editSend')}
            </Button>
        </css.editActions>
    );
}

export default AiAgentUserMessageEditActions;
